
import { writable, derived  } from 'svelte/store';
import { localStore } from './localStore'



function createSingleItem(obj = {}) {
	const { subscribe, set, get, update } = writable(obj);
  
	const updateBalances = (balances) => { 
		update(n => {
			
			balances.forEach( el => {
				if(n.balances[el.currency])
					n.balances[el.currency] = el.amount
			})

			return n
		})
			
	}

	return {
		subscribe,
		updateBalances,
		set: (val) => val ? set(val) : undefined
	};
}

function createHistoryList() {
	const { subscribe, set, update } = writable([]);
   
    const append = (val) => { 
        //update(n =>{ n.push(val); return n } )
		val.forEach(element => {
			update(n =>{ n.push(element); return n } )
		});
    }

    const prepend = (val) => { 
		val.forEach(element => {
			update(n =>{ n.unshift(element); return n } )
		});
       
    }

	const updateBet = (betId, data) => {
		update( n => { 
			let i = n.findIndex( el => el.id === betId)
			if(i > -1)
				n[i] = {... n[i], ...data }

			return n
		})
	}
	return {
		subscribe,
		append: append,
		prepend: prepend,
		updateBet,
		reset: () => set([])
	};
}

function createBetList(deriveFrom, maxItems = 200) {
	const { subscribe, set, update } = derived(deriveFrom, ($store, set) => {
		//console.log("> derived store 'BetList' callback \n")
		set($store.slice(-maxItems))
	}, []);
   
	

	//const { subscribe, set, update } = writable([]);

    const append = (val) => { 
        update(n =>{ n.push(val); return n } )
    }

    const prepend = (val) => { 
		val.forEach(element => {
			update(n =>{ n.unshift(element); return n } )
		});
       
    }

	let Filters = []
	return {
		subscribe,
		append: append,
		prepend: prepend,
		reset: () => set([]),
		set Filters (arr){ Filters = [... arr]},
		get Filters () { return Filters},
	};
}


function createList(maxItems = 200) {
	const { subscribe, set, update } = writable([]);
   
    const append = (val) => { 
        update(n =>{ n.push(val); return n.slice(-maxItems) } )
    }

    const prepend = (val) => { 
		val.forEach(element => {
			update(n =>{ n.unshift(element); return n.slice(-maxItems) } )
		});
       
    }

	return {
		subscribe,
		append: append,
		prepend: prepend,
		reset: () => set([])
	};
}

export const ChatMessages = { 
	de: createList(10),
	//en: createList(),
	challenges: createList(10),
}


export const Chat_De = ChatMessages.de
export const Chat_Challenges = ChatMessages.challenges

export const BetsHistory = createHistoryList() 
export const BetList = createBetList(BetsHistory)
export const LastBet = derived(BetsHistory, ($store, set) => {
	
	set({... ($store.slice(-1))[0]})
}, [])

export const BetFilterSettings = localStore("st_BetFilter", [])

const _user = {
	id: 0,
	name: "",
	loggedIn: false,
	balances: { 
		btc: 0
	},
	vault: {
		btc: 0
	}
}

export const User = createSingleItem(_user)

const _site_settings = {
	notifications: false
}

export const SiteSettings = localStore("SiteSettings",_site_settings)


export const BetSettingsLocal = localStore("BetSettings", { currency: 'btc', amount: 0, chance: 49.5, risk: "high", difficulty: "master", eggs: [], multiplierTarget: 2, rows: 16, segments: 50, numbers: [],minesCount: 12, fields: [], lines: 1 })

// [  "ape",    "cro",  "dai",    "link",   "pol",  "sand", "shib",  "sol",   "uni",    "usdc"]
const _stats = {
	session: {bets: 0, wager: 0, profit: 0, currency: "btc"},

	ape: {bets: 0, wager: 0, profit: 0 },
	btc: {bets: 0, wager: 0, profit: 0 },
 	bch: {bets: 0, wager: 0, profit: 0 },
 	cro: {bets: 0, wager: 0, profit: 0 },
 	dai: {bets: 0, wager: 0, profit: 0 },
	ltc: {bets: 0, wager: 0, profit: 0 },
	link: {bets: 0, wager: 0, profit: 0 },
	eth:  {bets: 0, wager: 0, profit: 0 },
	doge: {bets: 0, wager: 0, profit: 0 },
	trx:  {bets: 0, wager: 0, profit: 0 },
	xrp:  {bets: 0, wager: 0, profit: 0 },
	eos:  {bets: 0, wager: 0, profit: 0 },
	bnb:  {bets: 0, wager: 0, profit: 0 },
	usdt:  {bets: 0, wager: 0, profit: 0 },
	usdc:  {bets: 0, wager: 0, profit: 0 },
	sol:  {bets: 0, wager: 0, profit: 0 },
	pol:  {bets: 0, wager: 0, profit: 0 },
	sand:  {bets: 0, wager: 0, profit: 0 },
	shib:  {bets: 0, wager: 0, profit: 0 },
	uni:  {bets: 0, wager: 0, profit: 0 },
	gold:  {bets: 0, wager: 0, profit: 0 },
	sweeps:  {bets: 0, wager: 0, profit: 0 },


}
export const ApStatsLocal = localStore("ApStats", _stats)

const conversionRates = {
	lastUpdate: null, 
	ape: {btc: 0, eur: 0, usd: 0 },
	btc: {btc: 0, eur: 0, usd: 0 },
 	bch:  {btc: 0, eur: 0, usd: 0 },
 	cro:  {btc: 0, eur: 0, usd: 0 },
 	dai:  {btc: 0, eur: 0, usd: 0 },
	link: {btc: 0, eur: 0, usd: 0 },
	ltc: {btc: 0, eur: 0, usd: 0 },
	eth: {btc: 0, eur: 0, usd: 0 },
	doge:  {btc: 0, eur: 0, usd: 0 },
	trx:  {btc: 0, eur: 0, usd: 0 },
	xrp:   {btc: 0, eur: 0, usd: 0 },
	eos:  {btc: 0, eur: 0, usd: 0 },
	bnb:  {btc: 0, eur: 0, usd: 0 },
	usdt:  {btc: 0, eur: 0, usd: 0 },
	usdc:  {btc: 0, eur: 0, usd: 0 },
	sol:  {btc: 0, eur: 0, usd: 0 },
	pol:  {btc: 0, eur: 0, usd: 0 },
	sand:  {btc: 0, eur: 0, usd: 0 },
	shib:  {btc: 0, eur: 0, usd: 0 },
	uni:  {btc: 0, eur: 0, usd: 0 },
	gold:  {btc: 0, eur: 0, usd: 0 },
	sweeps:  {btc: 0, eur: 0, usd: 0 },
}
export const CurrencyConversionRates = localStore("CurrencyConversionRates", conversionRates)

export const ApiKey = localStore("apikey", "")
export const Mirror = localStore("stakemirror", "com")
export const setStakeMirror = (mirror = "com") => {
	console.log("set Stake Mirror: ", mirror)
	 Mirror.set(mirror)
}
//export const ApiKey = writable()